import { makeStyles } from '@map/theme';
import { SUBCONTENT_MAX_WIDTH } from '@shared/theme';
import { HTMLAttributes } from 'react';
import { createPortal } from 'react-dom';

const useStyles = makeStyles(({ zIndex, breakpoints, sizing, cssVars }) => ({
  content: {
    display: 'flex',
    justifyContent: 'center',
    zIndex: zIndex.modal,
    position: 'fixed',
    left: 0,
    bottom: 0,
    width: '100%',
    [breakpoints.up('md')]: {
      left: '50%',
      width: sizing(SUBCONTENT_MAX_WIDTH),
      marginLeft: `calc(${cssVars.sidebarWidth} / 2 - ${sizing(SUBCONTENT_MAX_WIDTH)} / 2)`,
    },
  },
  rightContent: {
    height: '100%',
    right: 0,
    [breakpoints.up('md')]: {
      left: 'unset',
      right: 0,
      width: sizing(90),
    },
  },
}));

type Props = HTMLAttributes<HTMLDivElement> & { position: 'bottom' | 'right' };
const ModalContent = ({ className, position = 'bottom', ...otherProps }: Props) => {
  const { classes, cx } = useStyles();
  return createPortal(
    <div
      className={cx(classes.content, position === 'right' && classes.rightContent, className)}
      {...otherProps}
    />,
    document.body,
  );
};

export default ModalContent;
